import { observer } from "mobx-react-lite";
import Modal from "react-modal";
import styles from "../../License.module.css";
import LicenseFormFields from "../licenseFormFields";

const createLicenseModal = ({ isOpenModal, setIsOpenModal, onSubmit }) => {
  const initialValues = {
    license_description: "",
    insurance_type: "Liability",
    policy_number: "",
    account_number: "",
    exp_date: "",
    cost: 0.0,
    paid: false,
    descript_ops: "",
    certificate_holder: "",
    filename: null,
  };

  return (
    <Modal
      isOpen={isOpenModal}
      onRequestClose={() => setIsOpenModal(!isOpenModal)}
      style={{
        overlay: {
          backgroundColor: "rgba(8, 24, 37, 0.58)",
          zIndex: "4000",
          backdropFilter: "blur(8px)",
        },
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          zIndex: "130",
          overflow: "auto",
          maxHeight: "88vh",
          width: "min(760px, 92vw)",
          padding: "20px",
          borderRadius: "22px",
          border: "1px solid rgba(23, 54, 74, 0.08)",
          boxShadow: "0 24px 60px rgba(8, 24, 37, 0.2)",
        },
      }}
    >
      <div>
        <span
          onClick={() => setIsOpenModal(!isOpenModal)}
          className={styles.closeBtn}
        >
          &#x2715;
        </span>
        <h3>Create New License</h3>
        <div>
          <LicenseFormFields
            initialValues={initialValues}
            onSubmit={onSubmit}
          />
        </div>
      </div>
    </Modal>
  );
};

export default observer(createLicenseModal);
